import { getAllParentsIds } from 'partner360/helpers/financialTable/getAllParentsIds'

interface IRowData {
  IsExpanded?: number | null
}

interface ICollapseSobCompetitorsTableRow<T> {
  data: T[]
  keyField: string
  hierarchyField: string
  keyFieldValue: string | number
}

export const collapseTableRow = <T extends IRowData>({
  data,
  hierarchyField,
  keyField,
  keyFieldValue,
}: ICollapseSobCompetitorsTableRow<T>) => {
  return data.map((el) => {
    if (el[keyField] === keyFieldValue) {
      const { IsExpanded, ...rest } = el
      return rest
    }
    const directParent = data.find((it) => it[keyField] === el[hierarchyField])
    if (directParent?.IsExpanded) {
      const parentIds = getAllParentsIds({
        data,
        hierarchyField,
        keyField,
        keyFieldValue: el[keyField],
      })
      if (parentIds.includes(keyFieldValue)) {
        const { IsExpanded, ...rest } = el
        return rest
      }
    }
    return el
  })
}
